// extracted by mini-css-extract-plugin
export default {"root":"ContactUs_root__7tvjB","title":"ContactUs_title__GSXjM","contact":"ContactUs_contact__Jz74U","contactItem":"ContactUs_contactItem__5rCkf"};